<ng-template bloodAddHost></ng-template>

<div class="gmb-96 gmb-md-56" [class.gmb-144]="editMode"></div>

<ng-container
  *ngTemplateOutlet="
    { form: formTemplate, loading: loadingTemplate, error: errorTemplate }[
      state
    ]
  "
></ng-container>

<ng-template #formTemplate>
  <app-form-page-footer [ngClass]="modal ? 'bg-white' : 'bg-lightblue-2'">
    <div class="d-sm-inline-flex d-flex gmb-sm-16 flex-column flex-sm-row">
      <button
        *ngIf="editMode"
        type="button"
        class="gbtn-red-2 gbtn-sq b2-semibold d-inline-flex align-items-center justify-content-center"
        gptDataTrack="analyses-edit-delete"
        (click)="closed.emit('delete')"
      >
        <span class="d-none d-md-block text-nowrap text-danger">
          {{ 'ANALYSES.DELETE.ACTION' | translate }}
        </span>
        <span class="d-block d-md-none text-nowrap text-danger">
          {{ 'ANALYSES.DELETE.ACTION_MOBILE' | translate }}
        </span>
      </button>

      <button
        type="submit"
        class="gbtn-1 gbtn-sq gbtn-spinner b2-semibold gmt-16 gmt-sm-0 gml-sm-16"
        [gptDataTrack]="
          editMode ? 'analyses-edit-submit' : 'analyses-add-submit'
        "
        [disabled]="!isValidForm"
        (click)="onSubmit()"
      >
        {{
          (editMode ? 'ANALYSES.EDIT.ACTION' : 'ANALYSES.ADD.TITLE') | translate
        }}
      </button>
    </div>
  </app-form-page-footer>
</ng-template>

<ng-template #errorTemplate>
  <div class="gp-alert gp-alert-danger p3-regular mb-4">
    <span class="p3-semibold">{{ 'ERROR' | translate }}</span>
    {{ 'FAILURE.GENERAL_ERROR.CONTENT' | translate }}
  </div>
</ng-template>

<ng-template #loadingTemplate>
  <gpu-loading-spinner-wrapper>
    <gpu-loading-spinner></gpu-loading-spinner>
  </gpu-loading-spinner-wrapper>
</ng-template>
